export default "__VITE_ASSET__CChxCOx8__"